import { useId, useState } from "react";
import { Button, Col, Container, FormGroup } from "reactstrap";
import { Component } from "../..";
import { App } from "../../app/App";
import { Api } from "../../shared";
import { Product } from "../product";

export const ProductDelete = ({onDelete, scripts}: {onDelete?: (mergeInto?: Api.Product.ProductSearchedType) => void, scripts: number}) =>
{
	const [product, setProduct] = useState<Api.Product.ProductSearchedType>();
	const [disabled, setDisabled] = useState(false);
	const [merging, setMerging] = useState(false);
	const id1 = useId();

	const click = async () =>
	{
		App.open(null, false);
		
		if(onDelete)
		{
			onDelete(product);
		}
	}

	if(merging)
	{
		return (
			<Container role="alertdialogue" aria-labelledby={id1}>
				<Col><h4 id={id1}>Product Merge Scripts and Deletion</h4></Col>
				<Col><p>
					This will clear {scripts} {scripts === 1 ? "script" : "scripts"} for other users.
					Before you delete, find an alternative product to convert these scripts into. 
				</p></Col>
				<Col>
					{product ? (
						<Product
							product={product}
							onRemove={() => {
								setProduct(undefined);
								setDisabled(true);
							}}
						/>
					) : (
						<Component.Store
							hidePersonalProducts={true}
							onClick={(p) => {
								setProduct(p);
								setDisabled(false);
							}}
						/>
					)}
				</Col>
				<Col><FormGroup>
					<Button disabled={disabled} onClick={click}>Ok</Button>
					<Button onClick={() => App.open(null, false)}>Cancel</Button>
				</FormGroup></Col>
			</Container>
		);
	}
	
	else
	{
		return (
			<Container role="alertdialogue" aria-labelledby={id1}>
				<Col><h4 id={id1}>Product Deletion</h4></Col>
				<Col><p>
					Are you sure you want to delete this
					product? 
				</p></Col>
				{scripts != null ? (
					<Col><p>
						This will clear {scripts} {scripts === 1 ? "script" : "scripts"} for other users. You may merge these
						scripts with an alternative product <span className="link" onClick={() => setMerging(true)}>here.</span>
					</p></Col>
				) : <></>}
				<Col><FormGroup>
					<Button disabled={disabled} onClick={click}>Yes</Button>
					<Button onClick={() => App.open(null, false)}>No</Button>
				</FormGroup></Col>
			</Container>
		);
	}
}

